module.exports = __webpack_public_path__ + "img/logo.b032f1b1.png";